import { has } from "../../../../utils/menu-context";
export const createConditionAction = () => {
    return {
        canEdit: ({ props }) => {
            let result = false
            const { menuContext } = props
            if (!has({ menuContext, key: 'canEdit' })) return false
            return true || result
        },
    }
}


export const createConditionForm = () => {
    return [
        {
            check: ({ field, conditionKey }) => {
                return !conditionKey && ['refAddr.phone', 'refAddr.fax'].includes(field?.key)
            },
            visibleField: () => false,
        },
    ]
}